import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"usercase"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M20.1213 9.41421C18.9497 10.1953 17.0503 10.1953 15.8787 9.41421C14.7071 8.63317 14.7071 7.36683 15.8787 6.58579C17.0503 5.80474 18.9497 5.80474 20.1213 6.58579C21.2929 7.36683 21.2929 8.63317 20.1213 9.41421Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M20.1213 17.4142C18.9497 18.1953 17.0503 18.1953 15.8787 17.4142C14.7071 16.6332 14.7071 15.3668 15.8787 14.5858C17.0503 13.8047 18.9497 13.8047 20.1213 14.5858C21.2929 15.3668 21.2929 16.6332 20.1213 17.4142Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M6.41421 9.41421C5.63317 10.1953 4.36683 10.1953 3.58579 9.41421C2.80474 8.63317 2.80474 7.36683 3.58579 6.58579C4.36683 5.80474 5.63317 5.80474 6.41421 6.58579C7.19526 7.36683 7.19526 8.63317 6.41421 9.41421Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 13H7M4.99984 16.0001V10.0001M4.99984 16.0001L3 17.999M4.99984 16.0001L7.00173 17.999M20.1213 9.41421C18.9497 10.1953 17.0503 10.1953 15.8787 9.41421C14.7071 8.63317 14.7071 7.36684 15.8787 6.58579C17.0503 5.80474 18.9497 5.80474 20.1213 6.58579C21.2929 7.36684 21.2929 8.63317 20.1213 9.41421ZM20.1213 17.4142C18.9497 18.1953 17.0503 18.1953 15.8787 17.4142C14.7071 16.6332 14.7071 15.3668 15.8787 14.5858C17.0503 13.8047 18.9497 13.8047 20.1213 14.5858C21.2929 15.3668 21.2929 16.6332 20.1213 17.4142ZM6.41421 9.41421C5.63317 10.1953 4.36684 10.1953 3.58579 9.41421C2.80474 8.63317 2.80474 7.36684 3.58579 6.58579C4.36684 5.80474 5.63317 5.80474 6.41421 6.58579C7.19526 7.36684 7.19526 8.63317 6.41421 9.41421Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10.5 8H11.5M10.5 16H11.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Usercase = Vue.extend<IconProps>({
  name: 'UsercaseIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'usercase',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Usercase;
